import * as THREE from 'three';
import { InsideType, TypeConnerModule } from '../../constants/enum';
import { GeometryUtils } from '../geometry/GeometryUtils';

export class ShortcutUtils {
  //Ẩn hiện cửa
  static visibleDoor(visibleDoor, openDoor, sceneManager) {
    //Xoá đi những bản clone hoặc pivot nếu cửa đang mở
    if (openDoor) {
      const toRemove = [];
      sceneManager.scene.traverse(obj => {
        if (obj.userData.isClone || obj.userData.isPivot) {
          toRemove.push(obj);
        }
      });
      toRemove.forEach(obj => obj.parent?.remove(obj));
    }

    if (!visibleDoor) {
      sceneManager.scene.traverse(object => {
        //Ẩn hiện cửa và tay nắm khi chuyển tab trong editor
        if (
          object.name.includes('CANH-LAT') ||
          object.name.includes('MAT-HOC') ||
          object.userData.type === InsideType.DOOR ||
          object.userData.type === InsideType.HANDLE ||
          object.userData.type === InsideType.LOCK
        ) {
          if (
            object?.parent?.userData?.layer > 0 ||
            object?.userData?.layer > 0
          ) {
            //không ẩn layer sau
          } else {
            object.visible = false;
            object.raycast = () => {};
          }
        }
      });
    } else {
      sceneManager.scene.traverse(object => {
        if (
          object.name.includes('CANH-LAT') ||
          object.name.includes('MAT-HOC') ||
          object.userData.type === InsideType.DOOR ||
          object.userData.type === InsideType.HANDLE ||
          object.userData.type === InsideType.LOCK
        ) {
          object.visible = true;
          object.raycast = THREE.Mesh.prototype.raycast;
        }
      });
    }

    sceneManager.handleDrawBorder();
  }

  static animateDoor(object, targetRotY, duration = 600, onComplete) {
    const startRotY = object.rotation.y;
    const startTime = performance.now();

    function update() {
      const elapsed = performance.now() - startTime;
      const t = Math.min(elapsed / duration, 1);
      const ease = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      object.rotation.y = startRotY + (targetRotY - startRotY) * ease;

      if (t < 1) {
        requestAnimationFrame(update);
      } else {
        onComplete?.();
      }
    }

    requestAnimationFrame(update);
  }

  //Đóng mở cửa
  static openDoor(openDoor, isAnimatingRef, sceneManager) {
    sceneManager.removeBorder();

    const duration = 600;

    if (!openDoor) {
      // ── MỞ CỬA ──

      // PASS 1: Xử lý DOOR trước
      sceneManager.scene.traverse(object => {
        if (
          object.userData.type === InsideType.DOOR &&
          !object.userData.drawerUuid
        ) {
          object.visible = false;
          object.raycast = () => {};

          //Chỉ xử lý xoay cho group
          if (!object.isGroup) return;

          const cloneDoor = object.clone();
          cloneDoor.visible = true;
          cloneDoor.userData.type = InsideType.DOOR_CLONE; //tránh bị rescale
          cloneDoor.userData.isClone = true;
          cloneDoor.userData.originalDoorUuid = object.uuid;

          const originalNodes = [];
          object.traverse(child => originalNodes.push(child));
          const cloneNodes = [];
          cloneDoor.traverse(child => cloneNodes.push(child));
          cloneNodes.forEach((cloneNode, index) => {
            cloneNode.userData.originalUuid = originalNodes[index].uuid;
            cloneNode.userData.isClone = true;
            cloneNode.userData.type = InsideType.DOOR_CLONE; //tránh bị rescale
          });

          if (object.userData.handlePosition?.current === 'left') {
            const orientation = GeometryUtils.getModuleOrientation(
              object.parent
            );
            const bbox = new THREE.Box3().setFromObject(object);
            const originalParent = object.parent;

            let worldPivotPos;
            if (orientation === 'NORMAL') {
              worldPivotPos = new THREE.Vector3(
                bbox.min.x,
                bbox.min.y,
                bbox.min.z
              );
            } else if (orientation === 'ROTATED_90') {
              worldPivotPos = new THREE.Vector3(
                bbox.min.x,
                bbox.min.y,
                bbox.max.z
              );
            } else if (orientation === 'ROTATED_180') {
              worldPivotPos = new THREE.Vector3(
                bbox.max.x,
                bbox.min.y,
                bbox.max.z
              );
            } else if (orientation === 'ROTATED_270') {
              worldPivotPos = new THREE.Vector3(
                bbox.max.x,
                bbox.min.y,
                bbox.min.z
              );
            }

            const localPivotPos = worldPivotPos.clone();
            originalParent.worldToLocal(localPivotPos);

            const pivot = new THREE.Group();
            pivot.userData.isPivot = true;
            pivot.userData.originalDoorUuid = object.uuid;
            pivot.position.copy(localPivotPos);

            originalParent.add(pivot);
            pivot.add(cloneDoor);

            const origPos = object.position.clone();
            cloneDoor.position.set(
              origPos.x - localPivotPos.x,
              origPos.y - localPivotPos.y,
              origPos.z - localPivotPos.z
            );
            cloneDoor.position.x -= 0.017;

            this.animateDoor(pivot, pivot.rotation.y + Math.PI / 2);
          } else if (object.userData.handlePosition?.current === 'right') {
            // DOOR right: giữ nguyên logic cũ
            object.parent.add(cloneDoor);
            cloneDoor.position.copy(object.position);
            cloneDoor.rotation.copy(object.rotation);
            cloneDoor.position.z -= 0.017;

            this.animateDoor(cloneDoor, cloneDoor.rotation.y - Math.PI / 2);
          }
        }
      });

      // PASS 2: Xử lý MIRROR_DOOR sau
      sceneManager.scene.traverse(object => {
        if (
          object.userData.type === InsideType.MIRROR_DOOR ||
          object.userData.type === InsideType.HANDLE ||
          object.userData.type === InsideType.LOCK
        ) {
          object.visible = false;
          object.raycast = () => {};

          const cloneHandleMirror = object.clone();
          cloneHandleMirror.visible = true;
          cloneHandleMirror.userData.isClone = true;
          cloneHandleMirror.userData.originalModelUuid = object.uuid;

          if (object.userData.type === InsideType.MIRROR_DOOR) {
            object.userData.mirrorCloneUuid = cloneHandleMirror.uuid;
          }

          const originalNodes = [];
          object.traverse(child => originalNodes.push(child));
          const cloneNodes = [];
          cloneHandleMirror.traverse(child => cloneNodes.push(child));
          cloneNodes.forEach((cloneNode, index) => {
            cloneNode.userData.originalUuid = originalNodes[index].uuid;
            cloneNode.userData.isClone = true;
          });

          // Lấy handlePosition từ linkedDoor
          let linkedDoor = null;
          sceneManager.scene.traverse(obj => {
            if (obj.uuid === object.userData.linkedDoorUuid) linkedDoor = obj;
          });
          const handlePosition =
            linkedDoor?.userData?.handlePosition?.current ?? 'right';

          const originalParent = object.parent;
          const orientation = GeometryUtils.getModuleOrientation(object.parent);

          if (handlePosition === 'left') {
            // Lấy world pos từ pivot của linkedDoor
            let pivotRef = null;
            sceneManager.scene.traverse(obj => {
              if (
                obj.userData.isPivot &&
                obj.userData.originalDoorUuid === object.userData.linkedDoorUuid
              ) {
                pivotRef = obj;
              }
            });

            let worldPivotPos;
            if (pivotRef) {
              worldPivotPos = new THREE.Vector3();
              pivotRef.getWorldPosition(worldPivotPos);
            } else {
              const bbox = new THREE.Box3().setFromObject(object);
              if (orientation === 'NORMAL') {
                worldPivotPos = new THREE.Vector3(
                  bbox.min.x,
                  bbox.min.y,
                  bbox.min.z
                );
              } else if (orientation === 'ROTATED_90') {
                worldPivotPos = new THREE.Vector3(
                  bbox.min.x,
                  bbox.min.y,
                  bbox.max.z
                );
              } else if (orientation === 'ROTATED_180') {
                worldPivotPos = new THREE.Vector3(
                  bbox.max.x,
                  bbox.min.y,
                  bbox.max.z
                );
              } else if (orientation === 'ROTATED_270') {
                worldPivotPos = new THREE.Vector3(
                  bbox.max.x,
                  bbox.min.y,
                  bbox.min.z
                );
              }
            }

            const localPivotPos = worldPivotPos.clone();
            originalParent.worldToLocal(localPivotPos);

            const pivot = new THREE.Group();
            pivot.userData.isPivot = true;
            pivot.userData.originalDoorUuid = object.uuid;
            pivot.position.copy(localPivotPos);

            originalParent.add(pivot);
            pivot.add(cloneHandleMirror);

            const origPos = object.position.clone();
            cloneHandleMirror.position.set(
              origPos.x - localPivotPos.x,
              origPos.y - localPivotPos.y,
              origPos.z - localPivotPos.z
            );
            cloneHandleMirror.position.x -= 0.017;

            this.animateDoor(pivot, pivot.rotation.y + Math.PI / 2);
          } else if (handlePosition === 'right') {
            // MIRROR_DOOR right: lấy trục từ clone của linkedDoor
            let linkedDoorClone = null;
            sceneManager.scene.traverse(obj => {
              if (
                obj.userData.isClone &&
                obj.userData.originalDoorUuid === object.userData.linkedDoorUuid
              ) {
                linkedDoorClone = obj;
              }
            });

            let worldPivotPos;

            if (!linkedDoorClone) return;

            const linkedBbox = new THREE.Box3().setFromObject(linkedDoorClone);
            if (linkedDoorClone.userData.typeHau === TypeConnerModule.SUB) {
              if (orientation === 'NORMAL') {
                worldPivotPos = new THREE.Vector3(
                  linkedBbox.max.x,
                  linkedBbox.min.y,
                  linkedBbox.min.z
                );
              } else if (orientation === 'ROTATED_90') {
                worldPivotPos = new THREE.Vector3(
                  linkedBbox.max.x,
                  linkedBbox.min.y,
                  linkedBbox.min.z
                );
              } else if (orientation === 'ROTATED_180') {
                worldPivotPos = new THREE.Vector3(
                  linkedBbox.min.x,
                  linkedBbox.min.y,
                  linkedBbox.max.z
                );
              } else if (orientation === 'ROTATED_270') {
                worldPivotPos = new THREE.Vector3(
                  linkedBbox.min.x,
                  linkedBbox.min.y,
                  linkedBbox.max.z
                );
              }
            } else {
              if (orientation === 'NORMAL') {
                worldPivotPos = new THREE.Vector3(
                  linkedBbox.min.x,
                  linkedBbox.min.y,
                  linkedBbox.max.z
                );
              } else if (orientation === 'ROTATED_90') {
                worldPivotPos = new THREE.Vector3(
                  linkedBbox.max.x,
                  linkedBbox.min.y,
                  linkedBbox.max.z
                );
              } else if (orientation === 'ROTATED_180') {
                worldPivotPos = new THREE.Vector3(
                  linkedBbox.max.x,
                  linkedBbox.min.y,
                  linkedBbox.min.z
                );
              } else if (orientation === 'ROTATED_270') {
                worldPivotPos = new THREE.Vector3(
                  linkedBbox.min.x,
                  linkedBbox.min.y,
                  linkedBbox.min.z
                );
              }
            }

            const localPivotPos = worldPivotPos.clone();
            originalParent.worldToLocal(localPivotPos);

            const pivot = new THREE.Group();
            pivot.userData.isPivot = true;
            pivot.userData.originalDoorUuid = object.uuid;
            pivot.position.copy(localPivotPos);

            originalParent.add(pivot);
            pivot.add(cloneHandleMirror);

            const origPos = object.position.clone();
            cloneHandleMirror.position.set(
              origPos.x - localPivotPos.x,
              origPos.y - localPivotPos.y,
              origPos.z - localPivotPos.z
            );
            cloneHandleMirror.position.z -= 0.017;

            this.animateDoor(pivot, pivot.rotation.y - Math.PI / 2);
          }
        }
      });
    } else {
      // ── ĐÓNG CỬA ──

      // PASS 1: Đóng DOOR
      sceneManager.scene.traverse(object => {
        if (object.isGroup && object.userData.type === InsideType.DOOR) {
          if (object.userData.handlePosition?.current === 'left') {
            let pivot = null;
            sceneManager.scene.traverse(obj => {
              if (
                obj.userData.isPivot &&
                obj.userData.originalDoorUuid === object.uuid
              ) {
                pivot = obj;
              }
            });

            if (pivot) {
              this.animateDoor(
                pivot,
                pivot.rotation.y - Math.PI / 2,
                duration,
                () => {
                  pivot.parent?.remove(pivot);
                  pivot.clear();
                  object.visible = true;
                  object.raycast = THREE.Mesh.prototype.raycast;
                }
              );
            }
          } else if (object.userData.handlePosition?.current === 'right') {
            // DOOR right: giữ nguyên logic cũ
            let cloneDoor = null;
            sceneManager.scene.traverse(obj => {
              if (
                obj.userData.isClone &&
                obj.userData.originalDoorUuid === object.uuid
              ) {
                cloneDoor = obj;
              }
            });

            if (cloneDoor) {
              this.animateDoor(
                cloneDoor,
                cloneDoor.rotation.y + Math.PI / 2,
                duration,
                () => {
                  cloneDoor.parent?.remove(cloneDoor);
                  object.visible = true;
                  object.raycast = THREE.Mesh.prototype.raycast;
                }
              );
            }
          } else {
            object.visible = true;
            object.raycast = THREE.Mesh.prototype.raycast;
          }
        } else if (object.userData.type === InsideType.DOOR) {
          object.visible = true;
          object.raycast = THREE.Mesh.prototype.raycast;
        }
      });

      // PASS 2: Đóng MIRROR_DOOR
      sceneManager.scene.traverse(object => {
        if (
          object.userData.type === InsideType.MIRROR_DOOR ||
          object.userData.type === InsideType.HANDLE ||
          object.userData.type === InsideType.LOCK
        ) {
          let linkedDoor = null;
          sceneManager.scene.traverse(obj => {
            if (obj.uuid === object.userData.linkedDoorUuid) linkedDoor = obj;
          });
          const handlePosition =
            linkedDoor?.userData?.handlePosition?.current ?? 'right';

          if (handlePosition === 'left') {
            let pivot = null;
            sceneManager.scene.traverse(obj => {
              if (
                obj.userData.isPivot &&
                obj.userData.originalDoorUuid === object.uuid
              ) {
                pivot = obj;
              }
            });

            if (pivot) {
              this.animateDoor(
                pivot,
                pivot.rotation.y - Math.PI / 2,
                duration,
                () => {
                  pivot.parent?.remove(pivot);
                  pivot.clear();
                  object.visible = true;
                  object.raycast = THREE.Mesh.prototype.raycast;
                }
              );
            }
          } else if (handlePosition === 'right') {
            // MIRROR_DOOR right: cũng dùng pivot nên đóng bằng pivot
            let pivot = null;
            sceneManager.scene.traverse(obj => {
              if (
                obj.userData.isPivot &&
                obj.userData.originalDoorUuid === object.uuid
              ) {
                pivot = obj;
              }
            });

            if (pivot) {
              this.animateDoor(
                pivot,
                pivot.rotation.y + Math.PI / 2,
                duration,
                () => {
                  pivot.parent?.remove(pivot);
                  pivot.clear();
                  object.visible = true;
                  object.raycast = THREE.Mesh.prototype.raycast;
                }
              );
            } else {
              object.visible = true;
              object.raycast = THREE.Mesh.prototype.raycast;
            }
          } else {
            object.visible = true;
            object.raycast = THREE.Mesh.prototype.raycast;
          }
        }
      });
    }

    setTimeout(() => {
      sceneManager.handleDrawBorder();
      isAnimatingRef.current = false; // unlock sau khi animation xong
    }, duration + 200);
  }
}
